import React from "react"
import styles from "./price.module.scss"

const Price = ({ price, compareAtPrice }) => {

  return(
    <>
      {compareAtPrice ? (
        <>
          <span className={styles.originalPrice}>
            <s>${compareAtPrice.toLocaleString()}</s>
          </span>
          <span className={styles.salePrice}>${price.toLocaleString()}</span>
        </>
      ) : (
        <>
          ${price.toLocaleString()}
        </>
      )}
    </>
  )
}

export default Price
